export const translations = {
  en: {
    // Navigation
    home: 'Home',
    about: 'About',
    projects: 'Projects',
    contact: 'Contact',
    resume: 'Resume',
    
    // Home page
    greeting: "Hello, I'm tushar",
    homeIntro: "A passionate full-stack developer with expertise in React, Node.js, and modern web technologies.",
    ctaViewProjects: 'View My Projects',
    ctaContactMe: 'Contact Me',
    
    // HomeInfo component
    homeInfoGreeting: "Hi, I'm",
    homeInfoName: "Tushar Kumar",
    homeInfoTitle: "Python & Backend Developer | AI & Automation Specialist",
    homeInfoStage2: "Completed 30+ end-to-end projects with Generative AI, backend systems, and automation. Strong in Django, FastAPI, PostgreSQL, and LLMs.",
    homeInfoStage2Btn: "Explore My Journey",
    homeInfoStage3: "Built AI-powered applications including resume optimization, learning platforms, automated reporting, and chat systems.",
    homeInfoStage3Btn: "View My Work",
    homeInfoStage4: "Looking for AI solutions or backend expertise? Let's build something amazing together!",
    homeInfoStage4Btn: "Get In Touch",
    
    // About page
    aboutGreeting: "Hey, I'm Tushar Kumar",
    aboutIntro: 'Results-driven Python & Backend Developer with hands-on experience in designing and deploying Generative AI, backend systems, automations, and data-driven applications. Strong command over Django, FastAPI, PostgreSQL, LLMs, LangChain, and automation tools.',
    transactionsProcessed: 'Projects Completed',
    activeUsers: 'GitHub Repositories',
    deliverySpeed: 'DSA Problems Solved',
    
    // Experience titles
    softwareDeveloper: 'Software Developer',
    backendDeveloper: 'Backend Developer',
    aiDeveloper: 'AI Developer',
    
    // Experience descriptions
    softwareExp1: 'Designed and deployed 10+ end-to-end projects including AI-powered applications',
    softwareExp2: 'Built scalable backend systems using Django, FastAPI, and PostgreSQL',
    softwareExp3: 'Implemented automation solutions reducing manual workload by up to 60%',
    
    backendExp1: 'Developed REST APIs and database architectures for high-performance applications',
    backendExp2: 'Implemented authentication, authorization, and data management systems',
    backendExp3: 'Optimized database queries and application performance',
    
    aiExp1: 'Integrated Generative AI models (Gemini, Hugging Face, Ollama) into applications',
    aiExp2: 'Built AI-powered features including resume evaluation, learning assistants, and chatbots',
    aiExp3: 'Implemented RAG systems, prompt engineering, and LangChain workflows',
    
    // Core Competencies
    coreCompetencies: 'Core Competencies',
    backendExpertise: 'Backend & API Engineering',
    backendDesc: 'Design and development of scalable backend systems using Django and FastAPI, with strong expertise in RESTful APIs, PostgreSQL, and system architecture best practices.',
    aiIntegration: 'AI & Agentic Systems Development',
    aiIntegrationDesc: 'Hands-on experience building Generative AI and agent-based systems using LangChain, LangGraph, Gemini, Ollama, RAG pipelines, and advanced prompt engineering techniques.',
    fullStack: 'Full Stack Application Development',
    fullStackDesc: 'End-to-end application development covering backend APIs, database design, and seamless frontend integration with a focus on performance and maintainability.',
    automation: 'Automation & Data Engineering',
    automationDesc: 'Development of robust automation workflows using Selenium and web scraping, combined with data processing, analysis, and pipeline creation using Pandas and background task orchestration.',
    problemSolving: 'Problem Solving & Data Structures',
    problemSolvingDesc: 'Strong problem-solving capabilities with 300+ Data Structures and Algorithms problems solved, demonstrating solid foundations in algorithms, optimization, and system-level thinking.',
    projectDelivery: 'Project Ownership & Delivery',
    projectDeliveryDesc: 'Proven ability to deliver complex projects from ideation to production, including deployment, optimization, and iterative improvement.',
    
    // Skills sections
    backendSkills: 'Backend & APIs',
    aiSkills: 'AI & Agentic Systems',
    programmingDB: 'Programming & Databases',
    automationData: 'Automation & Data',
    devopsTools: 'DevOps & Tools',
    csFundamentals: 'CS Fundamentals',
    csFundamentalsDesc: 'Strong foundation in core computer science concepts including data structures, algorithms, system design, and software engineering principles.',
    
    // Skills lists
    backendList: 'Django, FastAPI, Flask, REST APIs, Celery, JWT Auth',
    aiToolsList: 'LangChain, LangGraph, Gemini, Ollama, Hugging Face, RAG, Prompt Engineering',
    programmingList: 'Python, SQL, PostgreSQL, SQLite, ORM, Optimization',
    automationList: 'Selenium, BeautifulSoup, Pandas, NumPy, Matplotlib, Logging, Cron/Celery',
    devopsList: 'Git, GitHub, Docker, GitHub Actions, Linux, VS Code',
    csFundamentalsList: 'Data Structures & Algorithms, OOP, OS, DBMS, Computer Networks',
    
    // Education
    education: 'Education',
    btech: 'B.Tech in Computer Science Engineering',
    university: 'Dr. Akhilesh Das Gupta Institute of Technology & Management, Delhi',
    duration: '2021 - 2025',
    cgpa: 'CGPA',
    'class12th': '12th Class',
    school: 'Deep Public School, Vasant Kunj',
    
    // Projects Section
    projectsTitle: "Featured Projects",
    projectsIntro: "From enterprise-grade platforms to AI-powered developer tools. Each project reflects my journey of solving real-world problems, learning continuously, and delivering scalable, production-ready solutions.",
    
    // Project Descriptions
    projectPythonMasteryDesc: "Built a self-paced Python learning platform with AI assistants, automated quizzes, and progress tracking. Improved engagement by 40% through personalized assessments.",
    projectResumeAIDesc: "AI-driven system to evaluate resumes, identify skill gaps, and recommend tailored projects. Improved job readiness by 35% through guided upskilling.",
    projectSmartOpsDesc: "AI-powered automated reporting system with AI summaries, visualizations, and KPI extraction. Reduced manual reporting workload by 60%.",
    projectCivicComplaintDesc: "Web application for registering and tracking civic complaints with real-time status updates and role-based access control.",
    projectAutoNewsDesc: "Real-time web tool to scrape headlines, summarize news, and analyze sentiment from online articles using AI and automation.",
    projectChatZoneDesc: "Full-stack real-time chat application with AI integration using Django, WebSockets, and Generative AI.",
    projectGenAIHubDesc: "Multi-modal Generative AI platform for experimenting with text, image, audio, and chatbot use cases.",
    
    
    projectPythonMasteryTitle: 'Python Mastery Platform',
    projectResumeAITitle: 'Resume AI Analyzer',
    projectSmartOpsTitle: 'SmartOps Reporting',
    projectCivicComplaintTitle: 'Civic Complaint Portal',
    projectAutoNewsTitle: 'AutoNews Analyzer',
    projectChatZoneTitle: 'ChatZone AI Chat',
    projectGenAIHubTitle: 'GenAI Hub',
    
    // Metric translations
    metricUsers: 'Users',
    metricEngagement: 'Engagement',
    metricAccuracy: 'Accuracy',
    metricEfficiency: 'Efficiency',
    metricRevenue: 'Revenue',
    metricGrowth: 'Growth',

    // Project Features


    aiAssistants: "AI assistants in every lesson",
    automatedQuizzes: "Automated AI-generated quizzes",
    progressTracking: "Progress tracking and skill evaluation",
    personalizedLearning: "Personalized learning paths",
    resumeParsing: "AI-powered resume parsing",
    skillGapAnalysis: "Skill gap identification",
    projectRecommendations: "Personalized project recommendations",
    performanceTracking: "Performance history tracking",
    aiSummaries: "AI-powered summaries and insights",
    dataVisualization: "Automated data visualization",
    anomalyDetection: "Anomaly detection with AI",
    automatedReporting: "PDF/CSV report generation",
    roleBasedAccess: "Role-based access control",
    realtimeUpdates: "Real-time status updates",
    complaintTracking: "Complaint tracking system",
    
    // Project UI Components
    techStack: 'Tech Stack',
    keyFeatures: 'Key Features',
    keyMetrics: 'Key Metrics',
    fullStackDev: 'Full Stack Developer',
    clientWork: 'Client Work',
    personalProject: 'Personal Project',
    viewProject: 'View Project',
    liveDemo: 'Live Demo',
    viewCode: 'View Code',
    moreOnGitHub: 'More on GitHub',
    interestedWorking: "Interested in Working Together?",
    interestedWorkingDesc: "I'm always open to discussing new opportunities, innovative projects, or potential collaborations.",
    getInTouch: "Get In Touch",
    
//contact page
contactTitle: "Get In Touch",
contactIntro: "Feel free to reach out if you're looking for a developer, have a question, or just want to connect.",
yourName: "Your Name",
yourEmail: "Your Email", 
yourMessage: "Your Message",
messageSent: "Message sent successfully!",
messageFailed: "Failed to send message. Please try again.",
sending: "Sending...",
send: "Send Message",


    // Footer
    footerTitle: 'Let\'s Build Something Amazing Together',
    footerSubtitle: 'Open to exploring a range of entry-level and junior full-stack development roles.',
    allRightsReserved: '© 2025 Tushar Kumar. All rights reserved.',
  },

  // In your translations.js file, add these to both English and Hindi sections:

// ENGLISH translations (add these inside en: { ... })
projectKPRGTechTitle: 'KPRGTech',
projectKPRGTechDesc: 'Freelance development work delivering backend systems, automation tools, and AI-powered features for real-world clients.',
projectSolarTechTitle: 'SolarTech Gen', 
projectSolarTechDesc: 'Professional backend development work for a solar-focused web platform with structured data handling and deployment.',
projectResumeAITitle: 'Resume Optimizer AI',
projectResumeAIDesc: 'AI system that analyzes resumes, detects skill gaps, and recommends personalized projects and quizzes.',
projectAstroGPTTitle: 'AstroGPT',
projectAstroGPTDesc: 'AI-powered astrology assistant built using Generative AI for conversational insights and predictions.',
projectPythonMasteryTitle: 'Python Mastery',
projectPythonMasteryDesc: 'Self-paced Python learning platform with AI assistants, quizzes, and concept-based progression.',
projectCivicComplaintTitle: 'Civic Complaint Registration Portal',
projectCivicComplaintDesc: 'Platform for citizens to register and track complaints with role-based admin and user access.',
projectGenAIHubTitle: 'GenAI Hub',
projectGenAIHubDesc: 'Central hub to experiment with text, image, audio, and chatbot use cases using Generative AI APIs.',
projectPortfolioTitle: 'Portfolio (Old)',
projectPortfolioDesc: 'My earlier personal portfolio showcasing initial projects and skill evolution.',

// Also add these feature translations that you're missing:
clientBackendSolutions: "Client-based backend solutions",
apiIntegrations: "API integrations",
automationScripts: "Automation scripts",
scalableSystemDesign: "Scalable system design",
backendWorkflows: "Backend workflows",
databaseSchemaDesign: "Database schema design",
secureDataHandling: "Secure data handling",
resumeParsing: "Resume parsing",
skillGapDetection: "Skill gap detection",
aiProjectSuggestions: "AI project suggestions",
conversationalAI: "Conversational AI",
promptBasedResponses: "Prompt-based responses",
deployedAIService: "Deployed AI service",
aiTutor: "AI tutor",
personalizedLearningFlow: "Personalized learning flow",
complaintSubmission: "Complaint submission",
adminDashboard: "Admin dashboard",
statusTracking: "Status tracking",
multiModalAI: "Multi-modal AI",
promptPipelines: "Prompt pipelines",
reusableArchitecture: "Reusable architecture",
projectShowcase: "Project showcase",
personalBranding: "Personal branding",

// HINDI translations (add these inside hi: { ... })

  hi: {
    // Navigation
    home: 'होम',
    about: 'मेरे बारे में',
    projects: 'परियोजनाएं',
    contact: 'संपर्क',
    resume: 'रिज़्यूमे',
    
    // Home page
    greeting: "नमस्ते, मैं तुषार कुमार हूं",
    homeIntro: "परिणाम-संचालित पायथन और बैकएंड डेवलपर, AI-संचालित एप्लिकेशन, बैकएंड सिस्टम और ऑटोमेशन समाधानों में विशेषज्ञ।",
    ctaViewProjects: 'मेरी परियोजनाएं देखें',
    ctaContactMe: 'मुझसे संपर्क करें',
    
    // HomeInfo component
    homeInfoGreeting: "नमस्ते, मैं हूं",
    homeInfoName: "तुषार कुमार",
    homeInfoTitle: "पायथन और बैकएंड डेवलपर | AI और ऑटोमेशन विशेषज्ञ",
    homeInfoStage2: "जेनरेटिव AI, बैकएंड सिस्टम और ऑटोमेशन के साथ 30+ एंड-टू-एंड परियोजनाएं पूरी की हैं। Django, FastAPI, PostgreSQL और LLMs में मजबूत कौशल।",
    homeInfoStage2Btn: "मेरी यात्रा देखें",
    homeInfoStage3: "रिज्यूमे ऑप्टिमाइजेशन, लर्निंग प्लेटफॉर्म, ऑटोमेटेड रिपोर्टिंग और चैट सिस्टम जैसे AI-संचालित एप्लिकेशन बनाए हैं।",
    homeInfoStage3Btn: "मेरा काम देखें",
    homeInfoStage4: "AI समाधान या बैकएंड विशेषज्ञता की तलाश में हैं? आइए मिलकर कुछ अद्भुत बनाते हैं!",
    homeInfoStage4Btn: "संपर्क करें",
    
    // About page
    aboutGreeting: "नमस्ते, मैं तुषार कुमार हूं",
    aboutIntro: 'परिणाम-संचालित पायथन और बैकएंड डेवलपर जिसके पास जेनरेटिव AI, बैकएंड सिस्टम, ऑटोमेशन, और डेटा-संचालित एप्लिकेशन डिजाइन और डिप्लॉय करने का व्यावहारिक अनुभव है। Django, FastAPI, PostgreSQL, LLMs, LangChain और ऑटोमेशन टूल्स पर मजबूत कमांड।',
    transactionsProcessed: 'पूर्ण परियोजनाएं',
    activeUsers: 'GitHub रिपॉजिटरीज',
    deliverySpeed: 'DSA समस्याएं हल',
    
    // Experience titles
    softwareDeveloper: 'सॉफ्टवेयर डेवलपर',
    backendDeveloper: 'बैकएंड डेवलपर',
    aiDeveloper: 'AI डेवलपर',
    
    // Experience descriptions
    softwareExp1: 'AI-संचालित एप्लिकेशन सहित 10+ एंड-टू-एंड परियोजनाओं को डिजाइन और डिप्लॉय किया',
    softwareExp2: 'Django, FastAPI और PostgreSQL का उपयोग करके स्केलेबल बैकएंड सिस्टम बनाए',
    softwareExp3: 'मैनुअल वर्कलोड को 60% तक कम करने वाले ऑटोमेशन समाधान लागू किए',
    
    backendExp1: 'उच्च-प्रदर्शन एप्लिकेशन के लिए REST APIs और डेटाबेस आर्किटेक्चर विकसित किए',
    backendExp2: 'प्रमाणीकरण, अधिकार प्रबंधन और डेटा मैनेजमेंट सिस्टम लागू किए',
    backendExp3: 'डेटाबेस क्वेरी और एप्लिकेशन प्रदर्शन को ऑप्टिमाइज किया',
    
    aiExp1: 'जेनरेटिव AI मॉडल (Gemini, Hugging Face, Ollama) को एप्लिकेशन में एकीकृत किया',
    aiExp2: 'रिज्यूमे मूल्यांकन, लर्निंग असिस्टेंट और चैटबॉट्स सहित AI-संचालित फीचर्स बनाए',
    aiExp3: 'RAG सिस्टम, प्रॉम्प्ट इंजीनियरिंग और LangChain वर्कफ्लो लागू किए',
    
    // Core Competencies
    coreCompetencies: 'मुख्य क्षमताएं',
    backendExpertise: 'बैकएंड और API इंजीनियरिंग',
    backendDesc: 'Django और FastAPI का उपयोग करके स्केलेबल बैकएंड सिस्टम का डिजाइन और विकास, RESTful APIs, PostgreSQL और सिस्टम आर्किटेक्चर बेस्ट प्रैक्टिसेज में मजबूत विशेषज्ञता।',
    aiIntegration: 'AI और एजेंटिक सिस्टम डेवलपमेंट',
    aiIntegrationDesc: 'LangChain, LangGraph, Gemini, Ollama, RAG पाइपलाइन और उन्नत प्रॉम्प्ट इंजीनियरिंग तकनीकों का उपयोग करके जेनरेटिव AI और एजेंट-आधारित सिस्टम बनाने का व्यावहारिक अनुभव।',
    fullStack: 'फुल स्टैक एप्लिकेशन डेवलपमेंट',
    fullStackDesc: 'एंड-टू-एंड एप्लिकेशन डेवलपमेंट जिसमें बैकएंड APIs, डेटाबेस डिजाइन और प्रदर्शन और रखरखाव पर ध्यान देने के साथ सीमलेस फ्रंटएंड इंटीग्रेशन शामिल है।',
    automation: 'ऑटोमेशन और डेटा इंजीनियरिंग',
    automationDesc: 'Selenium और वेब स्क्रैपिंग का उपयोग करके मजबूत ऑटोमेशन वर्कफ्लो का विकास, Pandas और बैकग्राउंड टास्क ऑर्केस्ट्रेशन का उपयोग करके डेटा प्रोसेसिंग, विश्लेषण और पाइपलाइन निर्माण के साथ संयुक्त।',
    problemSolving: 'समस्या समाधान और डेटा संरचना',
    problemSolvingDesc: '300+ डेटा संरचना और एल्गोरिदम समस्याओं को हल करके प्रदर्शित मजबूत समस्या समाधान क्षमताएं, एल्गोरिदम, अनुकूलन और सिस्टम-स्तरीय सोच में ठोस नींव दिखाती हैं।',
    projectDelivery: 'प्रोजेक्ट स्वामित्व और डिलीवरी',
    projectDeliveryDesc: 'आइडिएशन से प्रोडक्शन तक जटिल परियोजनाओं को डिलीवर करने की सिद्ध क्षमता, जिसमें डिप्लॉयमेंट, ऑप्टिमाइजेशन और आवर्ती सुधार शामिल हैं।',
    
    // Skills sections
    backendSkills: 'बैकएंड और APIs',
    aiSkills: 'AI और एजेंटिक सिस्टम',
    programmingDB: 'प्रोग्रामिंग और डेटाबेस',
    automationData: 'ऑटोमेशन और डेटा',
    devopsTools: 'DevOps और टूल्स',
    csFundamentals: 'CS मूलभूत',
    csFundamentalsDesc: 'डेटा संरचना, एल्गोरिदम, सिस्टम डिजाइन और सॉफ्टवेयर इंजीनियरिंग सिद्धांतों सहित मूल कंप्यूटर विज्ञान अवधारणाओं में मजबूत नींव।',
    
    // Skills lists
    backendList: 'Django, FastAPI, Flask, REST APIs, Celery, JWT Auth',
    aiToolsList: 'LangChain, LangGraph, Gemini, Ollama, Hugging Face, RAG, Prompt Engineering',
    programmingList: 'Python, SQL, PostgreSQL, SQLite, ORM, Optimization',
    automationList: 'Selenium, BeautifulSoup, Pandas, NumPy, Matplotlib, Logging, Cron/Celery',
    devopsList: 'Git, GitHub, Docker, GitHub Actions, Linux, VS Code',
    csFundamentalsList: 'डेटा संरचना और एल्गोरिदम, OOP, OS, DBMS, कंप्यूटर नेटवर्क',
    
    // Education
    education: 'शिक्षा',
    btech: 'कंप्यूटर साइंस इंजीनियरिंग में बी.टेक',
    university: 'डॉ. अखिलेश दास गुप्ता इंस्टीट्यूट ऑफ टेक्नोलॉजी एंड मैनेजमेंट (ADGITM), दिल्ली',
    duration: '2021 - 2025',
    cgpa: 'CGPA: 9.0',
    'class12th': '12वीं कक्षा',
    school: 'डीप पब्लिक स्कूल, वसंत कुंज',
    
    // Projects Section
    projectsTitle: "विशेष परियोजनाएं",
    projectsIntro: "एंटरप्राइज-स्तरीय प्लेटफॉर्म से लेकर AI-संचालित डेवलपर टूल्स तक। प्रत्येक परियोजना वास्तविक समस्याओं को हल करने, निरंतर सीखने और स्केलेबल, प्रोडक्शन-रेडी समाधान प्रदान करने की मेरी यात्रा को दर्शाती है।",
    
    // Project Descriptions
    projectPythonMasteryDesc: "AI असिस्टेंट, ऑटोमेटेड क्विज और प्रोग्रेस ट्रैकिंग के साथ एक सेल्फ-पेस्ड पायथन लर्निंग प्लेटफॉर्म बनाया। व्यक्तिगत मूल्यांकन के माध्यम से सगाई को 40% तक बेहतर किया।",
    projectResumeAIDesc: "रिज्यूमे मूल्यांकन करने, स्किल गैप्स की पहचान करने और व्यक्तिगत परियोजनाओं की सिफारिश करने के लिए AI-संचालित सिस्टम। मार्गदर्शित स्किल डेवलपमेंट के माध्यम से नौकरी की तत्परता को 35% तक बेहतर किया।",
    projectSmartOpsDesc: "AI सारांश, विज़ुअलाइजेशन और KPI निष्कर्षण के साथ AI-संचालित ऑटोमेटेड रिपोर्टिंग सिस्टम। मैनुअल रिपोर्टिंग वर्कलोड को 60% तक कम किया।",
    projectCivicComplaintDesc: "वास्तविक समय स्थिति अपडेट और भूमिका-आधारित पहुंच नियंत्रण के साथ सिविक शिकायतों को पंजीकृत करने और ट्रैक करने के लिए वेब एप्लिकेशन।",
    projectAutoNewsDesc: "AI और ऑटोमेशन का उपयोग करके ऑनलाइन लेखों से हेडलाइन्स स्क्रैप करने, समाचारों को सारांशित करने और भावना विश्लेषण करने के लिए रीयल-टाइम वेब टूल।",
    projectChatZoneDesc: "Django, WebSockets और जेनरेटिव AI का उपयोग करके AI इंटीग्रेशन के साथ फुल-स्टैक रीयल-टाइम चैट एप्लिकेशन।",
    projectGenAIHubDesc: "टेक्स्ट, इमेज, ऑडियो और चैटबॉट उपयोग मामलों के साथ प्रयोग करने के लिए मल्टी-मोडल जेनरेटिव AI प्लेटफॉर्म।",
    projectPythonMasteryTitle: 'पायथन मास्टरी प्लेटफॉर्म',
    projectResumeAITitle: 'रिज़्यूम AI विश्लेषक',
    projectSmartOpsTitle: 'स्मार्टऑप्स रिपोर्टिंग',
    projectCivicComplaintTitle: 'नागरिक शिकायत पोर्टल',
    projectAutoNewsTitle: 'ऑटोन्यूज़ विश्लेषक',
    projectChatZoneTitle: 'चैटज़ोन AI चैट',
    projectGenAIHubTitle: 'जनरेटिव AI हब',
    
    // Metric translations in Hindi
    metricUsers: 'उपयोगकर्ता',
    metricEngagement: 'सगाई',
    metricAccuracy: 'सटीकता',
    metricEfficiency: 'दक्षता',
    metricRevenue: 'राजस्व',
    metricGrowth: 'वृद्धि',
    // Project Features
    aiAssistants: "प्रत्येक पाठ में AI असिस्टेंट",
    automatedQuizzes: "ऑटोमेटेड AI-जेनरेटेड क्विज",
    progressTracking: "प्रगति ट्रैकिंग और कौशल मूल्यांकन",
    personalizedLearning: "व्यक्तिगत शिक्षण पथ",
    resumeParsing: "AI-संचालित रिज्यूमे पार्सिंग",
    skillGapAnalysis: "कौशल अंतराल पहचान",
    projectRecommendations: "व्यक्तिगत परियोजना सिफारिशें",
    performanceTracking: "प्रदर्शन इतिहास ट्रैकिंग",
    aiSummaries: "AI-संचालित सारांश और अंतर्दृष्टि",
    dataVisualization: "ऑटोमेटेड डेटा विज़ुअलाइजेशन",
    anomalyDetection: "AI के साथ विसंगति पहचान",
    automatedReporting: "PDF/CSV रिपोर्ट जनरेशन",
    roleBasedAccess: "भूमिका-आधारित पहुंच नियंत्रण",
    realtimeUpdates: "वास्तविक समय स्थिति अपडेट",
    complaintTracking: "शिकायत ट्रैकिंग सिस्टम",
    
    // Project UI Components
    techStack: 'टेक स्टैक',
    keyFeatures: 'मुख्य विशेषताएं',
    keyMetrics: 'मुख्य मेट्रिक्स',
    fullStackDev: 'फुल स्टैक डेवलपर',
    clientWork: 'क्लाइंट वर्क',
    personalProject: 'व्यक्तिगत परियोजना',
    viewProject: 'प्रोजेक्ट देखें',
    liveDemo: 'लाइव डेमो',
    viewCode: 'कोड देखें',
    moreOnGitHub: 'GitHub पर और देखें',
    interestedWorking: "एक साथ काम करने में रुचि रखते हैं?",
    interestedWorkingDesc: "मैं नई अवसरों, नवीन परियोजनाओं या संभावित सहयोगों पर चर्चा करने के लिए हमेशा खुला हूं।",
    getInTouch: "संपर्क करें",

    projectKPRGTechTitle: 'केपीआरजीटेक',
    projectKPRGTechDesc: 'वास्तविक दुनिया के ग्राहकों के लिए बैकएंड सिस्टम, ऑटोमेशन टूल्स और एआई-संचालित सुविधाएं वितरित करने वाला फ्रीलांस विकास कार्य।',
    projectSolarTechTitle: 'सोलरटेक जेन', 
    projectSolarTechDesc: 'संरचित डेटा हैंडलिंग और डिप्लॉयमेंट के साथ सौर-केंद्रित वेब प्लेटफॉर्म के लिए पेशेवर बैकएंड विकास कार्य।',
    projectAstroGPTTitle: 'एस्ट्रोजीपीटी',
    projectAstroGPTDesc: 'जनरेटिव एआई का उपयोग करके बनाया गया एआई-संचालित ज्योतिष सहायक संवादी अंतर्दृष्टि और भविष्यवाणियों के लिए।',
    projectPortfolioTitle: 'पोर्टफोलियो (पुराना)',
    projectPortfolioDesc: 'शुरुआती परियोजनाओं और कौशल विकास को दर्शाने वाला मेरा पहला व्यक्तिगत पोर्टफोलियो।',

// Hindi feature translations
clientBackendSolutions: "क्लाइंट-आधारित बैकएंड समाधान",
apiIntegrations: "एपीआई एकीकरण",
automationScripts: "ऑटोमेशन स्क्रिप्ट्स",
scalableSystemDesign: "स्केलेबल सिस्टम डिजाइन",
backendWorkflows: "बैकएंड वर्कफ्लो",
databaseSchemaDesign: "डेटाबेस स्कीमा डिजाइन",
secureDataHandling: "सुरक्षित डेटा हैंडलिंग",
skillGapDetection: "कौशल अंतराल पता लगाना",
aiProjectSuggestions: "एआई परियोजना सुझाव",
conversationalAI: "संवादी एआई",
promptBasedResponses: "प्रॉम्प्ट-आधारित प्रतिक्रियाएं",
deployedAIService: "डिप्लॉय किया गया एआई सेवा",
aiTutor: "एआई ट्यूटर",
personalizedLearningFlow: "व्यक्तिगत शिक्षण प्रवाह",
complaintSubmission: "शिकायत जमा करना",
adminDashboard: "एडमिन डैशबोर्ड",
statusTracking: "स्थिति ट्रैकिंग",
multiModalAI: "मल्टी-मोडल एआई",
promptPipelines: "प्रॉम्प्ट पाइपलाइन",
reusableArchitecture: "पुन: प्रयोज्य आर्किटेक्चर",
projectShowcase: "परियोजना प्रदर्शनी",
personalBranding: "व्यक्तिगत ब्रांडिंग",
    


    //contact section
    // In the English section (en: { ... }), add these:

// In the Hindi section (hi: { ... }), add these:
    contactTitle: "संपर्क करें",
    contactIntro: "अगर आप एक डेवलपर की तलाश में हैं, कोई प्रश्न है, या बस जुड़ना चाहते हैं तो बेझिझक संपर्क करें।",
    yourName: "आपका नाम",
    yourEmail: "आपका ईमेल",
    yourMessage: "आपका संदेश",
    messageSent: "संदेश सफलतापूर्वक भेज दिया गया!",
    messageFailed: "संदेश भेजने में विफल। कृपया पुनः प्रयास करें।",
    sending: "भेज रहा हूँ...",
    send: "संदेश भेजें",
    // Footer
    footerTitle: 'आइए मिलकर कुछ अद्भुत बनाते हैं',
    footerSubtitle: 'एंट्री-लेवल और जूनियर फुल-स्टैक डेवलपमेंट भूमिकाओं की एक श्रृंखला का पता लगाने के लिए खुला हूं।',
    allRightsReserved: '© 2025 तुषार कुमार। सर्वाधिकार सुरक्षित।'
  }
};